export const ROOT_FOLDER_ID = 0;

export const ROOT_DIR = {
  root: true,
  folderSlug: ROOT_FOLDER_ID,
  name: 'panel.layouts.panel_navbar.documents',
};
